module.exports = __webpack_public_path__ + "static/media/seasponge 0.1.02dcbbf0.svg";